$(document).ready(function() {

    let lang = localStorage.getItem('MSDFLang');
    console.log("wf101- from inint  js");
    $("#bankAccounts-list").owlCarousel({
        loop: false,
        rtl: (lang == 'ar') ? true : false,
        video: true,
        lazyLoad: false,
        autoplay: true,
        autoplayTimeout: 4000,
        margin: 30,
        nav: false,
        dots: true,
        //navText: [$('.op-2'), $('.on-2')],
        responsive: {
            0: {
                items: 1
            },
            768: {
                items: 3
            }
        }
    });

    $("#bankAccounts-list .owl-nav button").attr("tabindex", "-1");

    var $tabs = $('#horizontalTab');
    $tabs.responsiveTabs({
        rotate: false,
        startCollapsed: 'accordion',
        collapsible: 'accordion',
        setHash: true,
        classes: {
            stateDefault: 'r-tabs-default',
            stateActive: 'r-tabs-active',
            stateDisabled: 'r-tabs-disabled',
            stateExcluded: 'r-tabs-excluded',
            container: 'r-tabs',
            ul: 'r-tabs-nav',
            tab: 'r-tabs-tab',
            anchor: 'r-tabs-anchor',
            panel: 'r-tabs-panel',
            accordionTitle: 'r-tabs-accordion-title'
        }

    });
    //$tabs.responsiveTabs('activate', 0);

    //$('.tableToCards').stacktable();
    //$('.tableToCards').cardtable();

    var input = document.querySelector(".phone");


});